import React, { useCallback, useEffect, useState } from "react";

import {
  UpdatesLabel,
  GridContainerTemplates,
  Container,
  Header
} from "./styles";

import { useNavigate } from "react-router-dom";
import { AllMyProjects } from "../../dtos/AllMyProjects";
import api from "../../services/api";
import Template from "./components/Template";
import { FlexPagination, Text } from "../myclausules/screen/styles";
import Pagination from "../../shared/components/Pagination";
import { LoadingFlex } from "../login/pages/Login/styles";
import LoadingEditor from "../editor/components/LoadingEditor";
import { useMainHook } from "../../hooks/main";
import { ContractAnimation } from "../../shared/components/ContractAnimation";

interface QuerySharedWithMeProps {
  pagination: number;
}

const SharedWithMe: React.FC = () => {
  const [templateIDSelectedPopUp, setTemplateIDSelectedPopUp] =
    useState<string>("");
  const { objectScreen, setObjectScreen } = useMainHook();
  const navigator = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [allMyProjects, setAllMyProjects] = useState<AllMyProjects[]>([]);
  const [loading, setLoading] = useState(true);

  const [params, setParams] = useState<QuerySharedWithMeProps>({
    pagination: 0
  });

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const fetchAllMyTemplates = await api.get(
          "user-templates/shared-with-me",
          {
            params: {
              pagination: params.pagination
            }
          }
        );

        setAllMyProjects(fetchAllMyTemplates.data.dataArray as AllMyProjects[]);
        setTotalPages(fetchAllMyTemplates.data.pagination);
        setLoading(false);
      } catch (error) {
        console.log("ERROR GETTING TEMPLATES " + error);
        setLoading(false);
      }
      api.get("user-templates");
    })();
  }, [params]);

  // Closing popUp
  useEffect(() => {
    window.addEventListener("click", (event: any) => {
      let aboutElement = event.target.getAttribute("about");

      if (aboutElement !== "button-popup") setTemplateIDSelectedPopUp("");
    });
  }, []);

  const handleChooseTemplate = async (myProject: AllMyProjects) => {
    //currentTemplateInfo.current = myProject;
    try {
      const response = await api.get(`user-templates/${myProject.id}`);

      setObjectScreen(response.data.template.arrayOfPages);
      navigator(`editor/my-template/${myProject.id}`);
    } catch (err) {
      console.log(err, "error when get specific template");
    }
  };

  const handleDeleteDocument = async (document_id: string) => {
    try {
      if (window.confirm("Tem certeza que deseja excluir este documento ?")) {
        await api.delete(`user-templates/${document_id}`);

        setAllMyProjects(prevState => {
          let newArray = prevState.filter(document => {
            return document.id !== document_id;
          });

          return newArray;
        });
      } else {
      }
    } catch (error) {
      console.log("error trying to delete document", error);
    }
  };

  const handleChangeDocumentName = useCallback(
    (userDocument: AllMyProjects, newDocumentName: string) => {
      try {
        api.put("user-templates", {
          user_template_id: userDocument.id,
          template: {
            ...userDocument.template
          },
          title: newDocumentName,
          description: userDocument.description
        });
      } catch (error: any) {
        console.log(
          "Error trying to update document's name",
          error.response.data
        );
      }
    },
    []
  );

  return (
    <>
      {loading ? (
        <LoadingFlex>
          <ContractAnimation />
        </LoadingFlex>
      ) : (
        <Container>
          <Header>
            <UpdatesLabel>Compartilhados comigo</UpdatesLabel>
          </Header>

          {allMyProjects.length === 0 && !loading && (
            <div className="centered">
              <span>
                Nenhum arquivo foi compartilhado com você até o momento.
              </span>
            </div>
          )}

          <GridContainerTemplates>
            {allMyProjects.map((item, index) => {
              let defaultIMG = false;
              let splitURL = item.thumbnail_url.split("/");

              if (splitURL[splitURL.length - 1] === "default")
                defaultIMG = true;

              return (
                <Template
                  key={String(Math.random())}
                  loading={loading}
                  setLoading={setLoading}
                  userDocument={item}
                  handleChangeDocumentName={handleChangeDocumentName}
                  index={1}
                  handleChooseTemplate={() => {
                    handleChooseTemplate(item);
                  }}
                  handleDelete={() => {
                    handleDeleteDocument(item.id);
                  }}
                  handleDownload={() => {}}
                  handleChangeProjectsName={() => {}}
                  handleMakeCopy={() => {}}
                  templateIDSelectedPopUp={templateIDSelectedPopUp}
                  setTemplateIDSelectedPopUp={setTemplateIDSelectedPopUp}
                  name={item.title}
                  url={
                    defaultIMG
                      ? "https://picnic.com.br/wp-content/uploads/2017/12/pagina-em-branco-catalogo-1.jpg"
                      : item.thumbnail_url
                  }
                />
              );
            })}
          </GridContainerTemplates>

          <div
            style={{
              width: "100%",
              height: "200px",
              paddingBottom: "2rem",
              display: "flex",
              marginTop: "-4rem"
            }}
          >
            {allMyProjects.length > 0 && (
              <FlexPagination>
                <Pagination
                  total={totalPages}
                  offset={params.pagination}
                  setDataParams={setParams}
                  dataParams={params}
                />
              </FlexPagination>
            )}
          </div>
        </Container>
      )}
    </>
  );
};

export default SharedWithMe;
